module.exports = __webpack_public_path__ + "static/projectsbgLight-9386eea15614709faf4adb5eb99404fa.png";